const a = (t) => !!t && ["16/9", "4/3", "3/4", "1/1", "9/16", "5/2"].includes(t);
export {
  a as default
};
